/* eslint-disable */

import StoreClient from "../Client";
import axios from "axios";
import { setting } from "../setting";

const GET_IDENTITY = /* GraphQL */ `
  {
    identity: me {
      id
      username
      email
      createdAt
      status
      role
      profile {
        id
        name
        image
        card
      }
      employeeInfo {
        id
        phones
        theatre {
          id
          originalId
          city {
            id
          }
        }
      }
    }
  }
`;

export const fetchData = authKey => {
  console.log('authKey', authKey);

  return axios({
    url: setting.authHost + '/identity?withProfile=true',
    withCredentials: true,
  }).then(response => {
    return response.data;
  }).catch(e => console.log(e));

  return StoreClient.setHeader("authKey", authKey)
    .request(GET_IDENTITY)
    .then(res => {

      const { identity } = res;
      if (!identity) {
        console.log('error: Unauthorized');
      }
      return identity;
    })
    .catch(e => console.log(e))
};
